import * as React from "react";
import { matchPath, Route, useLocation, useMatch, Routes, matchRoutes, resolvePath } from "react-router";
import { Link } from "react-router-dom";
import { Tab, TabProps } from "@/components/bp/bp-ui";
import { RouteContent } from "@common/RouteContent";
import { isNullOrWhitespace } from "@common/Utils";

export interface IRoutedTabProps extends TabProps {
    tabs: Array<{ path: string | string[], to: string, menuItem: any, exact?: boolean, enabled?: boolean, render: (route: any) => any }>;
    onTabChange?: (e: React.MouseEvent<HTMLDivElement>, data: TabProps) => void;
}

function MatchPath({ path, Comp }) {
    let match = useMatch(path);
    return match ? Comp() : null;
}

export function RoutedTab(props: IRoutedTabProps) {
    const location = useLocation();

    const makeNestedRoutes = (path, render, key) => {
        if (path.endsWith('/*')) {
            const cleanPath = path.substring(0, path.length - 2);
            return (<Route key={key} path={cleanPath}>
                <Route path="*" index element={<RouteContent render={render}></RouteContent>} />
            </Route>)
        }
        else {
            return <Route key={key} index={isNullOrWhitespace(path) || path === "*"} path={path} element={<RouteContent render={render}></RouteContent>} />;
        }
    }

    const panes = props.tabs.map((t, i) => {

        return {
            menuItem: {
                as: t.enabled ? Link : 'span',
                id: `tab${i}`,
                content: typeof t.menuItem === 'string' ? t.menuItem : t.menuItem.content,
                to: t.enabled ? t.to : '',
                key: `tab${i}`,
                disabled: !t.enabled,
                path: t.path
            },
            pane: (
                <React.Fragment key={`rkey_${i}`}>
                    <Routes>
                        {t.path instanceof Array
                            ? t.path.map((p, idx) => makeNestedRoutes(p, t.render, `rkey_${i}_${idx}`))
                            : makeNestedRoutes(t.path, t.render, `rkey_${i}`)
                        }

                        {/* {t.path instanceof Array
                            ? t.path.map((p, idx) => <Route index={isNullOrWhitespace(p) || p === "*"} key={`rkey_${i}_${idx}`} path={p} element={<RouteContent render={t.render}></RouteContent>} />)
                            : <Route key={`rkey_${i}`} index={isNullOrWhitespace(t.path) || t.path === "*"} path={t.path} element={<RouteContent render={t.render}></RouteContent>} />
                        } */}
                    </Routes>
                </React.Fragment>
            )
        };
    });

    // const routes = matchRoutes(panes.map(p => ({ path: p.menuItem.path as string })), location);
    // console.log('routes', routes);

    // Required to get a correct tab opened by default
    const defaultActiveIndex = panes.findIndex(pane => {
        const resolvedPath = resolvePath(pane.menuItem.to as string, location.pathname)?.pathname;
        const match = matchPath({ path: resolvedPath, caseSensitive: false, end: true }, location.pathname);

        return !!match;
    });

    const selectedActiveIndex = panes.findIndex(pane => {
        const resolvedPath = resolvePath(pane.menuItem.to as string, location.pathname)?.pathname;
        const match = matchPath({ path: resolvedPath, caseSensitive: false, end: true }, location.pathname);
        return !!match;
    });

    // console.log('defaultActiveIndex', defaultActiveIndex, 'selectedActiveIndex', selectedActiveIndex);

    return (
        <>
            {/* <Switch> */}

            <Tab onTabChange={props.onTabChange} renderActiveOnly={false} activeIndex={Math.max(selectedActiveIndex, 0)} defaultActiveIndex={Math.max(defaultActiveIndex, 0)}
                panes={panes}
                menu={props.menu ?? { widths: 2, pointing: true, vertical: false, tabular: false }} />
            {/* </Switch> */}
        </>
    );
}
